var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"scene-signup"},[_c(_vm.stepComponent,{tag:"component",attrs:{"authModel":_vm.authModel,"userModel":_vm.userModel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }